import { Paper, styled, PaperProps } from "@mui/material";

const ModalLike = styled(Paper)<
  PaperProps & {
    size?: "small" | "medium" | "large";
  }
>(({ size = "medium" }) => {
  const width = size === "medium" ? 540 : size === "large" ? 668 : 360;

  const padding = size === "medium" ? 30 : size === "large" ? 40 : 20;

  return {
    maxWidth: width,
    margin: "auto",
    width: "100%",
    padding,
    paddingBottom: padding * 1.5,
    marginTop: 75,
    marginBottom: 75,
    [`@media (max-width: ${width}px)`]: {
      height: "100vh",
      marginTop: 0,
      marginBottom: 0,
    },
  };
});

export default ModalLike;
